<template>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-title">
                <div class="accordion-toggle collapsed" :href="'#collapse_' + parent + '_' + info.folder.alias" data-toggle="collapse">
                    <div class="papka-bkg">{{ info.folder.title }}</div>
                </div>
            </div>
        </div>
        <div :id="'collapse_' + parent + '_' + info.folder.alias" class="panel-collapse collapse" style="height: 0px;">
            <div class="panel-body">
                <div class="" v-if="token">
                  <a href="" :data-folder="info.folder.alias" class="btn btn-success" @click.prevent="uploadModal">
                    Добавить файл
                  </a>
                  <br>
                  <br>
                </div>
                <ul v-if="info.files"  class="kris-doclist ekis" >
                    <file v-bind:key="item.id" v-for="item in info.files" :info="item" />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import File from './File'

import { mapState } from 'vuex'
export default {
  name: 'Folder',
  components: {
    'file': File,
  },

  data () {
    return {
    }
  },

  props: [
    'info',
    'parent'
  ],

  computed: {
    ...mapState({
      token: 'token',
      eoId: 'eoId'
    })
  },

  methods: {
    uploadModal (e) {
      let selectFolder = e.target.getAttribute('data-folder')
      this.$store.commit('setSelectFolder', selectFolder)
      this.$modal.show('upload-modal')
    },
  }
}
</script>

<style lang="less">

</style>
